<ion-item [button]="true" [detail]="false" [disabled]="disabled" (click)="open()">
  <ion-label>
    <div class="field-label tw:text-xs">
      <ng-content select="[searchable-select-label]"></ng-content>
    </div>

    <div class="field-value">
      @if (value) {
        {{ getDisplayValue(value) }}
      } @else {
        <span class="placeholder">
          {{ placeholder }}
        </span>
      }
    </div>
  </ion-label>

  @if (value && !disabled) {
    <ion-icon name="close-circle" slot="end" (click)="$event.stopPropagation(); clear()" />
  } @else {
    <ion-icon class="tw:text-lg" name="chevron-expand-outline" slot="end" />
  }
</ion-item>

@if (errorText) {
  <div class="bottom-text tw:mx-4 tw:leading-5">
    <div class="error-text">
      <ion-note class="tw:text-xs" color="danger">
        {{ errorText }}
      </ion-note>
    </div>
  </div>
}
<ion-popover
  #popover
  [isOpen]="isOpen"
  [dismissOnSelect]="false"
  (didDismiss)="onPopoverDismiss()"
  (didPresent)="onPopoverDidPresent()"
>
  <ng-template>
    <div class="tw:max-h-80 tw:w-full">
      <div>
        <ion-searchbar
          #searchbar
          [value]="searchTerm"
          [placeholder]="searchPlaceholder"
          [debounce]="150"
          (ionInput)="onSearchChange($event)"
          (keydown)="onSearchKeydown($event)"
        />
      </div>
      <div class="tw:max-h-60 tw:overflow-y-scroll">
        <ion-list lines="none">
          @if (hasCustomValue) {
            <ion-item [button]="true" [detail]="false" (click)="selectCustomValue()">
              <ion-icon name="add-outline" slot="start" />

              <ion-label>
                {{ customValuePrefix }}
                <strong>"{{ customValue }}"</strong>
              </ion-label>
            </ion-item>
          }

          @for (option of filteredOptions; track option.value) {
            <ion-item [button]="true" [detail]="false" (click)="selectOption(option)">
              <ion-label>
                {{ displayWith(option) }}
              </ion-label>
            </ion-item>
          }

          @if (!filteredOptions.length && !hasCustomValue) {
            <ion-item>
              <ion-label class="ion-text-center">
                {{ noResultsText }}
              </ion-label>
            </ion-item>
          }
        </ion-list>
      </div>
    </div>
  </ng-template>
</ion-popover>
